<template>
  <div class="home">
    <!-- 顶部 -->
    <Tab :kexs="1"></Tab>
    <!-- body -->
    <div class="body">
      <!-- 筛选 -->
      <div class="Screen">
        <div class="Screen-box">
          <div class="Screen-name">标的类型</div>
          <div
            @click="(key = -1), (objecttypeId = '')"
            class="Screen-quanbu pointer"
          >
            全部
          </div>
          <div class="Screen-text inner">
            <div
              class="Screen-textDiv pointer"
              :class="key == item.id ? 'color' : ''"
              v-for="(item, index) in list1"
              :key="'y-' + index"
              @click="handleList1(item.id)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="Screen-box">
          <div class="Screen-name">标的所在地</div>
          <div class="Screen-quanbu pointer" @click="handleQb()">全部</div>
          <Leftmain @zdy_show="showdata" @zdy_shows="showdatas" :leftmain='provinceId'></Leftmain>
        </div>
        <div class="Screen-box">
          <div class="Screen-name">标的状态</div>
          <div
            @click="(keys = -1), (statusId = '')"
            class="Screen-quanbu pointer"
          >
            全部
          </div>
          <div class="Screen-text inner">
            <div
              class="Screen-textDiv pointer"
              :class="keys == items.id ? 'color' : ''"
              v-for="(items, indexs) in lists"
              :key="indexs"
              @click="handleLists(items.id)"
            >
              {{ items.name }}
            </div>
          </div>
        </div>
      </div>
      <!-- 拍品列表 -->
        <el-empty v-if="lbList.length == 0" description="暂时没有数据哦~"></el-empty>
      <div class="Lots">
        <div
          class="Lots-box"
          v-for="(item, index) in lbList"
          :key="'lot-' + index"
          @click="page('Details',item.id,item.auction_id)"
        >
          <div class="Lots-img">
            <img :src="item.images_text[0]" @error="errorImg" alt="" />
            <!-- status  0,未发布 1，已发布  2，正在进行  3，即将开始  4，已暂停  5，已成交  6，未成交  7.已撤回 -->
            <div class="Lots-text" v-if="item.status == 2">正在进行</div>
            <div class="Lots-text Lots-text1" v-else-if="item.status == 3">
              即将开始
            </div>
            <div class="Lots-text Lots-text2" v-else-if="item.status == 5">
              已成交
            </div>
            <div class="Lots-text Lots-text3" v-else>
              {{item.status_text}}
            </div>
          </div>
          <div style="position: relative">
            <div class="Lots-name van-ellipsis">{{ item.title }}</div>
            <div class="Lots-money">
              当前价：<span class="Lots-moneys"
                >{{ item.current_price }}元</span
              >
            </div>
            <div class="Lots-time">开始时间：{{ item.start_time }}</div>
            <div v-if="item.biddingmode == 1" class="AuctionList-right-text">
              减价
            </div>
            <div v-else class="AuctionList-right-text AuctionList-right-text1">
              增价
            </div>
          </div>
        </div>
        <!-- 分页 -->
        <div class="page page1">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage3"
            :page-size="12"
            layout="prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
          <div class="pointer tz">跳转</div>
        </div>
        <div class="page page2">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage3"
            :page-size="12"
            layout="prev, pager, next"
            :total="total"
            small
          >
          </el-pagination>
        </div>
      </div>
      <!-- 保障 -->
      <Guarantee></Guarantee>
    </div>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
import Tab from "@/components/tab.vue";
import Footer from "@/components/footer.vue";
import Guarantee from "@/components/Guarantee.vue";
import Leftmain from "@/components/leftmain.vue";
export default {
  name: "Home",
  data() {
    return {
      list1: [],
      list: [],
      lists: [],
      currentPage3: 1, //默认分页
      key:this.$route.params.objecttypeId ||  -1, // 标类型
      keys: -1, // 标状态
      lbList: [], // 标的列表
      province: this.$route.params.province || " ", // 省
      city: " ", // 市
      objecttypeId: this.$route.params.objecttypeId || " ", // 标类型id
      statusId: " ", // 标状态id
      total: 0, //共多少条
      provinceId:this.$route.params.provinceId || '' , // 省id
    };
  },
  watch: {
    objecttypeId() {
      this.handlelist(sessionStorage.getItem('title'),1);
    },
    statusId() {
      this.handlelist(sessionStorage.getItem('title'),1);
    },
    province() {
      this.handlelist(sessionStorage.getItem('title'),1);
    },
    city() {
      this.handlelist(sessionStorage.getItem('title'),1);
    },
  },
  mounted() {
    // 拍品类型
    this.$apis.objecttype().then((res) => {
      this.list1 = res.data;
    });
    // 标的状态
    this.$apis.objectstatus().then((res) => {
      this.lists = res.data;
    });
    this.handlelist('',1);
    
    if (window.performance.navigation.type == 1) {
        sessionStorage.removeItem('title')
        console.log('页面被刷新')
      }else{
        console.log("首次被加载")
      }
  },
  destroyed(){
    sessionStorage.removeItem('title')
  },

  components: {
    Tab,
    Footer,
    Guarantee,
    Leftmain,
  },
  methods: {
    // 省
    showdata(msg) {
      this.province = msg;
    },
    // 市
    showdatas(msg) {
      this.city = msg;
    },
    errorImg(event) {
      this.$pk.errorImg(event);
    },
    page(e,id,auction_id) {
      this.$router.push({
        name: e,
        query: {
          id: id,
          auction_id:auction_id
        },
      });
    },
    // 标类型选择
    handleList1( id) {
      this.key = id;
      this.objecttypeId = id;
    },
    // 标状态选择
    handleLists(id) {
      this.keys = id;
      this.statusId = id;
    },
    // 标列表
    handlelist(title,page) {
      this.$apis
        .ObjectmanagementList({
          title:title || this.$route.params.title, // 关键词
          objecttype_id: this.objecttypeId, // 标的类型id
          address_city:
            this.city == " " ? this.province : this.province + "," + this.city, // 地区  格式：山东省,临沂市
          status: this.statusId, // 标的状态id
          page: page,
          pagesize: 12,
        })
        .then((res) => {
          this.lbList = res.data.data;
          this.total = res.data.total;
        });
    },
    handleQb(){
      this.province = ' '
      this.city = ' '
      let dates = new Date()
      this.provinceId = dates.getTime() 
    },
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.handlelist(sessionStorage.getItem('title'),val);
    },
  },
};
</script>
<style scoped='scoped'>
img {
  width: 100%;
  height: 100%;
}
i {
  font-size: 18px;
}
.home {
  overflow-x: hidden;
  background-color: #f5f5f5;
}
.body {
  width: 1136px;
  margin: 0 auto;
  padding: 16px 0 0;
}
.Screen {
  background-color: #fff;
}
.Screen-box {
  display: flex;
  padding: 12px 0 0;
  font-size: 16px;
  border-bottom: 1px solid #e5e5e5;
}
.Screen-name {
  width: 15%;
  padding-left: 24px;
}
.Screen-quanbu {
  width: 6%;
  color: #c7171e;
  font-weight: bold;
}
.Screen-text {
  display: flex;
  width: 75%;
  flex-wrap: wrap;
  overflow: hidden;
}
.Screen-textDiv {
  margin: 0 24px 12px 0;
  color: #999;
}
.Screen-textDivo {
  width: 12%;
  color: #999;
  margin-bottom: 24px;
}
/*  */
.Lots {
  margin: 24px 0;
  display: flex;
  /* justify-content: space-between; */
  flex-wrap: wrap;
}
.Lots-box {
  background-color: #fff;
  width: 24.1%;
  margin-bottom: 24px;
  margin-right: 1.2%;
}
.Lots-img {
  width: 100%;
  height: 196px;
  position: relative;
}
.Lots-text {
  padding: 4px 16px;
  font-size: 14px;
  color: #fff;
  background-color: #c7171e;
  position: absolute;
  top: 0;
  right: 0;
}
.Lots-text1 {
  background-color: #18a2d6;
}
.Lots-text2 {
  background-color: #3bd38e;
}
.Lots-text3 {
  background-color: #999999;
}
.Lots-name {
  font-size: 18px;
  padding: 14px 0px 10px 16px;
  width: 70%;
}
.Lots-money {
  font-size: 14px;
  color: #666;
  padding-left: 16px;
}
.Lots-moneys {
  color: #c7171e;
  font-size: 20px;
}
.Lots-time {
  font-size: 14px;
  color: #666;
  padding: 12px 0 30px 16px;
}
.AuctionList-right-text {
  width: 80px;
  height: 29px;
  background: #18a2d6;
  opacity: 1;
  border-radius: 15px 0px 0px 15px;
  font-size: 14px;
  color: #fff;
  text-align: center;
  line-height: 29px;
  position: absolute;
  top: 15px;
  right: 0;
}
.AuctionList-right-text1 {
  background-color: #e95000;
}
/* 分页 */
.el-pagination >>> .el-pager li {
  padding: 0;
  margin: 0 4px;
}
.el-pagination >>> .el-pager li.active {
  background-color: #c7171e;
  color: #fff;
}
.tz {
  width: 69px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  background: #ffffff;
  font-size: 14px;
  color: #999;
  border-radius: 4px;
  border: 1px solid #c0c4cf;
}
.page {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.page2 {
  display: none;
}
.color {
  color: #c7171e;
}
@media only screen and (min-width: 991px) {
  .Lots-box:nth-child(4n) {
    margin-right: 0;
  }
}
@media screen and (min-width: 991px) and (max-width: 1160px) {
  .body {
    width: 98%;
    margin: 0 auto;
  }
  .Screen-box {
    font-size: 16px;
  }
}
@media screen and (min-width: 768px) and (max-width: 991px) {
  .body {
    width: 98%;
    margin: 0 auto;
  }
  .Screen-box {
    font-size: 16px;
  }
  .Screen-name {
    padding-left: 12px;
  }
  .Screen-textDivo {
    width: 13%;
  }
  .Lots-box {
    width: 30.7%;
    margin-right: 3.8%;
  }

  .Lots-box:nth-child(3n) {
    margin-right: 0;
  }
}
@media only screen and (max-width: 767px) {
  .body {
    width: 98%;
    margin: 0 auto;
    padding: 10px 0 0;
  }
  i {
    font-size: 14px;
  }
  .Screen-box {
    font-size: 14px;
  }
  .Screen-name {
    width: 23%;
    padding-left: 5px;
  }
  .Screen-quanbu {
    width: 10%;
  }
  .Screen-textDivo {
    width: 22%;
    white-space: nowrap;
    margin: 0 10px 14px 0;
  }
  .Screen-textDiv {
    margin: 0 10px 10px 0;
    white-space: nowrap;
  }
  .Screen-text {
    overflow: auto;
    flex-wrap: nowrap;
  }
  .Lots-img {
    height: 135px;
  }
  .Lots-box {
    width: 49.1%;
    margin-right: 1.8%;
  }
  .Lots-box:nth-child(2n) {
    margin-right: 0;
  }
  .AuctionList-right-text {
    width: 50px;
    height: 22px;
    line-height: 22px;
  }
  .Lots-name {
    font-size: 16px;
    padding: 10px 0px 10px 5px;
  }
  .Lots-money {
    padding-left: 5px;
  }
  .Lots-moneys {
    font-size: 18px;
  }
  .Lots-time {
    padding: 7px 0 20px 5px;
  }

  .page1 {
    display: none;
  }
  .page2 {
    display: flex;
  }
}
</style>
